import { PropertyType } from "../types";

export enum BindingType {
    Const= "Const",
    Field = "Field",
    Expression = "Expression"
}

export interface IBinding {
    propId: string,
    propType: PropertyType,
    type: BindingType,
}
